import { Button, HStack, Text } from "native-base";
import React from "react";

import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppSelector } from "@/hooks/application/store";
import { RootNavigation } from "@/navigation/Root";
import { formatToCurrency } from "@/utils/helpers";
import { isIos } from "@/utils/platform";

const CartFloatingButton = () => {
  const { navigateBetweenStacks } = useAppNavigation<RootNavigation>();

  const { items, subtotal } = useAppSelector((store) => store.checkout);

  const onPressButton = () => navigateBetweenStacks("cartStack");

  return (
    <HStack
      position="absolute"
      bottom={isIos ? "94px" : "64px"}
      w="full"
      px="2"
      justifyContent="space-between"
      alignItems="center"
      zIndex={9999999}>
      <Button onPress={onPressButton}>
        <Text color="light.50">
          <Text color="light.50" bold>
            {items?.size}
          </Text>{" "}
          itens
        </Text>
      </Button>
      <Button _text={{ bold: true }} onPress={onPressButton}>
        {formatToCurrency(subtotal)}
      </Button>
    </HStack>
  );
};

export default CartFloatingButton;
